// extracted by mini-css-extract-plugin
module.exports = {"introduction":"style__introduction__P4HIQ","block":"style__block__RDqEe"};